import React from 'react';
export function MechanismSection() {
  return <section id="come-funziona" className="py-6 md:py-9 px-5 bg-[radial-gradient(ellipse_at_bottom_left,rgba(0,102,255,0.15)_0%,transparent_60%),linear-gradient(180deg,var(--dark-bg),var(--card-bg))]" data-id="element-85" data-mp="322cfzoyq453j">
      <div className="max-w-[900px] mx-auto" data-id="element-86" data-mp="8c1mwswq5eg0">
        <span className="inline-block font-heading font-bold text-[0.75rem] tracking-[3px] uppercase text-magenta-bright mb-2" data-id="element-87" data-mp="8d383q7gfhbg">
          Il meccanismo
        </span>
        <h2 className="text-[clamp(1.6rem,4vw,2.5rem)] font-heading font-black leading-[1.15] mb-3" data-id="element-88" data-mp="103hlllbk2rml">
          Così funziona il
          <br data-id="element-89" data-mp="vbg15c48hulh" />
          <span className="text-gradient-blue" data-id="element-90" data-mp="vay4wfhkngdk">Ciclo P-C-V</span> —<br data-id="element-91" data-mp="rbfljo5efdcu" />e così
          si interrompe
        </h2>
        <div className="flex flex-col md:flex-row items-center justify-center gap-0 my-4 flex-wrap" data-id="element-92" data-mp="ranrihrg9noo">
          {/* Node 1: Piacere */}
          <div className="text-center py-4 px-4 rounded-2xl flex-1 min-w-[140px] max-w-[200px] bg-gradient-to-br from-[rgba(255,165,0,0.2)] to-[rgba(255,215,0,0.1)] border-2 border-[rgba(255,165,0,0.5)]" data-id="element-93" data-mp="1j2by0nnjrfzl">
            <div className="text-[2.5rem] mb-[10px]" data-id="element-94" data-mp="cplhjo3mczb6">✨</div>
            <div className="font-heading font-black text-[1.3rem] mb-2 text-gold" data-id="element-95" data-mp="cr4wnbdjh4bd">
              PIACERE
            </div>
            <div className="text-[0.85rem] text-white/65 leading-[1.5]" data-id="element-96" data-mp="2z8w7tnzd23z">
              Il cervello cerca di riempire il vuoto con una ricompensa
              immediata
            </div>
          </div>
          <div className="text-[2rem] text-white/25 py-[5px] md:px-[10px] shrink-0 rotate-90 md:rotate-0" data-id="element-97" data-mp="3q3ouegvevhff">
            →
          </div>
          {/* Node 2: Colpa */}
          <div className="text-center py-4 px-4 rounded-2xl flex-1 min-w-[140px] max-w-[200px] bg-gradient-to-br from-[rgba(194,0,111,0.2)] to-[rgba(107,0,182,0.1)] border-2 border-[rgba(194,0,111,0.5)]" data-id="element-98" data-mp="3b8seril9vrsb">
            <div className="text-[2.5rem] mb-[10px]" data-id="element-99" data-mp="19d8cfhl1o9mi">⚡</div>
            <div className="font-heading font-black text-[1.3rem] mb-2 text-magenta-bright" data-id="element-100" data-mp="1edco8ub0cg6e">
              COLPA
            </div>
            <div className="text-[0.85rem] text-white/65 leading-[1.5]" data-id="element-101" data-mp="1cv5pkmg68oue">
              La vergogna non guarisce — svuota di più. E un vuoto più profondo
              richiede più piacere
            </div>
          </div>
          <div className="text-[2rem] text-white/25 py-[5px] md:px-[10px] shrink-0 rotate-90 md:rotate-0" data-id="element-102" data-mp="yxh5vhxubnqx">
            →
          </div>
          {/* Node 3: Vuoto */}
          <div className="text-center py-4 px-4 rounded-2xl flex-1 min-w-[140px] max-w-[200px] bg-gradient-to-br from-[rgba(0,102,255,0.2)] to-[rgba(0,207,255,0.1)] border-2 border-[rgba(0,102,255,0.5)]" data-id="element-103" data-mp="1vmyiyhz5kc2n">
            <div className="text-[2.5rem] mb-[10px]" data-id="element-104" data-mp="1lvu4rkhawv8v">🌀</div>
            <div className="font-heading font-black text-[1.3rem] mb-2 text-blue-light" data-id="element-105" data-mp="1hva96lcdlzou">
              VUOTO
            </div>
            <div className="text-[0.85rem] text-white/65 leading-[1.5]" data-id="element-106" data-mp="2efix0ta70cme">
              La tensione interna irrisolta alimenta l'impulso successivo
            </div>
          </div>
          <div className="text-[2rem] text-white/25 py-[5px] md:px-[10px] shrink-0 rotate-90 md:rotate-0" data-id="element-107" data-mp="3sbkkzyufbqlm">
            ↩
          </div>
        </div>
        <div className="bg-gradient-to-br from-[rgba(107,0,182,0.25)] to-[rgba(194,0,111,0.15)] border border-[rgba(107,0,182,0.5)] rounded-2xl p-5 mt-3" data-id="element-108" data-mp="55jiiuavmdz4">
          <h3 className="text-[1.25rem] font-heading font-bold text-gold mb-2" data-id="element-109" data-mp="a5frl7yfkvlj">
            🔑 Il vero motivo per cui non riesci a fermarti
          </h3>
          <div className="text-[1rem] leading-[1.6] text-white/85 space-y-2" data-id="element-110" data-mp="k2kexb40ix3x">
            <p data-id="element-111" data-mp="k0hery95bnlh">
              Il tuo cervello non cerca il piacere perché sei debole. Lo cerca
              perché a un certo punto ha imparato che il piacere{' '}
              <strong data-id="element-112" data-mp="sumbgyaynt8x">copre il vuoto.</strong> Una tensione interna senza nome,
              che il comportamento interrompe temporaneamente.
            </p>
            <p data-id="element-113" data-mp="12ssbfad7ipb5">
              Il problema è ciò che arriva dopo: la colpa. La colpa non ti
              guarisce — <strong data-id="element-114" data-mp="p62ztjeo69ih">ti svuota di più.</strong> Genera una versione
              più profonda del vuoto originale. E un vuoto più profondo richiede
              più piacere per essere coperto.
            </p>
            <p className="text-gold font-bold" data-id="element-115" data-mp="ywnyt7y99g1x">
              PIACERE, COLPA E VUOTO interrompe quel circolo dall'interno — con
              pratiche quotidiane specifiche per ogni punto del ciclo.
            </p>
          </div>
        </div>
      </div>
    </section>;
}